// Configuration settings for the application
const config = {
  // Shop information
  shopName: "Sri Tirupati Crackers",
  
  // API URL - Change this to your server's IP or hostname when deploying
  // Examples:
  // - Development: "http://localhost:8000/api"
  // - Production: "http://192.168.1.100:8000/api" or "https://your-domain.com/api"
  apiUrl: "https://nexus-ecom-zigr.onrender.com/api",
  
  // Currency symbol
  currencySymbol: "₹",
  
  // Social Media Links
  whatsappNumber: "919994657772", // Without + sign
  socialMedia: {
    instagram: "https://www.instagram.com/sritirupaticrackers?utm_source=qr&igsh=MW1nZWk4eWZ4aXl3dA==",
    facebook: "https://www.facebook.com/sritirupati.crackers", 
    youtube: "https://youtube.com/@sritirupaticrackers5394?si=wRsbs5YZFBYlUkXO"
  }
};

export default config;